import SeparateLine from '@/shared/Forms/SeparateLine'
import AvatarUpload from '@/pages/User/AccountSettingsSidePage/components/AvatarUpload'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import { useRecoilState } from 'recoil'
import userAtom from '@/pages/User/user.atom.ts'
import { IAvatar } from '@/pages/Users/users.types.ts'
import useAccountSettingsCtrl from '@/pages/User/AccountSettingsSidePage/hooks/useAccountSettingsCtrl.ts'
import useAvatarSettingsCtrl from '@/pages/User/AccountSettingsSidePage/hooks/useAvatarSettingsCtrl.ts'
import userApi from '@/pages/User/user.api.ts'
import Button from '@/shared/Buttons/Button'

interface IProps {
  onClose: () => void
}

const PersonalDataContent = (props: IProps) => {
  const { wait: waitSubmitFormRequest, loading: submitFormLoading } = useHttpLoader()
  const [userState, setUserState] = useRecoilState(userAtom)

  const onAvatarUpload = (avatar: IAvatar) => {
    accountSettingsCtrl.setUserInfoDraft((prev) => ({ ...prev, avatar: avatar }))
    setUserState((prev) => ({ ...prev, userInfo: { ...prev.userInfo, avatar } }))
  }

  const accountSettingsCtrl = useAccountSettingsCtrl({ user: userState })
  const avatarSettingsCtrl = useAvatarSettingsCtrl({ onAvatarUpload })

  const handleSave = () => {
    const userRequest = userApi.updateSelfInfo(accountSettingsCtrl.userInfoDraft)

    waitSubmitFormRequest(userRequest, (resp) => {
      if (resp.status === 'success') {
        setUserState((prev) => ({ ...prev, userInfo: { ...prev.userInfo, ...resp.body } }))
      }
    })
  }

  return (
    <div className="flex-lines gap16 height100">
      <AvatarUpload
        user={userState}
        fileInputHandler={avatarSettingsCtrl.fileInputHandler}
        loading={avatarSettingsCtrl.avatarLoading}
      />
      <FormField label="Фамилия" required={true}>
        <TextInput
          value={accountSettingsCtrl.userInfoDraft.lastName}
          name="lastName"
          onChange={accountSettingsCtrl.handleUserInfoDraftChange}
          placeHolder="Введите фамилию"
        />
      </FormField>
      <FormField label="Имя" required={true}>
        <TextInput
          value={accountSettingsCtrl.userInfoDraft.firstName}
          name="firstName"
          onChange={accountSettingsCtrl.handleUserInfoDraftChange}
          placeHolder="Введите имя"
        />
      </FormField>
      <FormField label="Отчество" required={false}>
        <TextInput
          value={accountSettingsCtrl.userInfoDraft.middleName}
          name="middleName"
          onChange={accountSettingsCtrl.handleUserInfoDraftChange}
          placeHolder="Введите отчество"
        />
      </FormField>
      <SeparateLine />

      <div style={{ paddingRight: '24px', marginTop: 'auto' }} className="flex-lines gap16">
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button
            size="default"
            type="primary"
            text="Сохранить"
            loading={submitFormLoading}
            disabled={!accountSettingsCtrl.isUserDraftChanged}
            onClick={handleSave}
          />
          <Button size="default" type="default" text="Отменить" onClick={props.onClose} disabled={submitFormLoading} />
        </div>
      </div>
    </div>
  )
}

export default PersonalDataContent
